module.exports = __webpack_public_path__ + "img/table-edit-icon.6bfeea5c.svg";